import React from 'react';

import Navbar from 'components/Navbar';
import SettingSidebar from 'components/Navbar/SettingsSidebar';
import { NAV_BAR_HEIGHT_REM } from 'utils/dimensions';
import CommentsHeader from './CommentsHeader';
import CommentsTable from './CommentsTable';

const CommentsList: React.FC = () => {
  const warningBarOffset =
    document != null &&
    document.getElementById != null &&
    document.getElementById('customer-warning')?.offsetHeight;

  return (
    <>
      <div
        className="min-w-screen bg-white"
        style={{
          height: `calc(100vh - ${warningBarOffset}px)`,
        }}
      >
        <Navbar />
        <div
          className="flex flex-row w-full"
          style={{
            height: `calc(100vh - ${warningBarOffset}px - ${NAV_BAR_HEIGHT_REM}rem)`,
          }}
        >
          <SettingSidebar />

          <div className="w-full h-full pt-4 flex flex-col gap-2 overflow-hidden">
            <CommentsHeader />
            <main className="w-full h-full flex flex-col overflow-hidden">
              <CommentsTable />
            </main>
          </div>
        </div>
      </div>
    </>
  );
};

export default CommentsList;
